module.exports = __webpack_public_path__ + "img/header-illu.bfcbc1cc.svg";